import gql from 'graphql-tag';

// Query adapted from program-skills-objectives/components/ProgramSkillRecommendationsPage/withSkillDetails.ts
export const EnterpriseSkillDetails = gql`
  query EnterpriseSkillDetails($input: GetSkillRequest!) {
    GetSkill(input: $input) @rest(type: "GetSkillResponse", path: "grpc/skills/v2/SkillsAPI/GetSkill", method: "POST") {
      skill {
        skillDescription
      }
    }
  }
`;
